import { Helmet } from 'react-helmet';
import AboutUs from '../../components/home/AboutUs/AboutUs';
import BackLinks from '../../components/home/BackLinks/BackLinks';
import ContactUs from '../../components/home/ContactUs/ContactUs';
import GoogleMap from '../../components/home/GoogleMap/GoogleMap';
import HeroSection from '../../components/home/HeroSection/HeroSection';
import Projects from '../../components/home/Projects/Projects';
import Services from '../../components/home/Services/Services';

import style from './HomePage.module.css';
import { useEffect, useState } from 'react';

const HomePage = ({}) => {
  return (
    <>
      <Helmet>
        <title>Artemida Studio - Creative Digital Solutions</title>
        <meta
          name="description"
          content="Artemida Studio - Creative digital solutions for modern businesses. We specialize in design, branding, and innovative web development."
        />
        <meta
          name="keywords"
          content="web development, branding, design, creative solutions, UI/UX, graphic design, marketing, modern businesses"
        />
        <link rel="canonical" href="https://artemidastudio.com/" />
      </Helmet>
      <div className={style.homePage}>
        <HeroSection />
        <AboutUs />
        <Services />
        <Projects />
        <ContactUs />
        <BackLinks />
        <GoogleMap />
      </div>
    </>
  );
};

export default HomePage;
